'use strict';

/**
* DropDownLst custom element.
*/
JQX('jqx-drop-down-list', function (_JQX$ContentElement) {
    babelHelpers.inherits(DropDownList, _JQX$ContentElement);

    function DropDownList() {
        babelHelpers.classCallCheck(this, DropDownList);
        return babelHelpers.possibleConstructorReturn(this, (DropDownList.__proto__ || Object.getPrototypeOf(DropDownList)).apply(this, arguments));
    }

    babelHelpers.createClass(DropDownList, [{
        key: 'template',


        /**
        * DropDownList's HTML template.
        */
        value: function template() {
            return '<div id="container">\n                    <div id="buttonsContainer" class = "jqx-unselectable">\n                        <span id="actionButton" class="jqx-action-button ">[[placeholder]]</span>\n                        <span id="dropDownButton" class="jqx-drop-down-button">&#xe804</span>\n                    </div>\n                    <jqx-list-box id="listBox" class ="jqx-popup jqx-visibility-hidden"\n                            data-source="[[dataSource]]"\n                            disabled="[[disabled]]"\n                            display-loading-indicator="[[displayLoadingIndicator]]"\n                            display-member="[[displayMember]]"\n                            filterable="[[filterable]]"\n                            filter-mode="[[filterMode]]"\n                            filter-input-placeholder="[[filterInputPlaceholder]]"\n                            grouped="[[grouped]]"\n                            group-member="[[groupMember]]"\n                            item-height="[[itemHeight]]"\n                            item-template="[[itemTemplate]]"\n                            incremental-search-delay="[[incrementalSearchDelay]]"\n                            incremental-search-mode="[[incrementalSearchMode]]"\n                            loading-indicator-placeholder="[[loadingIndicatorPlaceholder]]"\n                            loading-indicator-position="[[loadingIndicatorPosition]]"\n                            placeholder="[[dropDownPlaceholder]]"\n                            readonly="[[readonly]]"\n                            selected-indexes="{{selectedIndexes}}"\n                            selection-mode="[[selectionMode]]"\n                            selected-values="{{selectedValues}}"\n                            sorted="[[sorted]]"\n                            value-member="[[valueMember]]"\n                            virtualized="[[virtualized]]">\n                        <content></content>\n                    </jqx-list-box>\n                </div>';
        }

        /**
        * Updates the DropDownList when a property is changed.
        * @param {string} propertyName The name of the property.
        * @param {number/string} oldValue The previously entered value. Max, min and value are of type Number. The rest are of type String.
        * @param {number/string} newValue The new entered value. Max, min and value are of type Number. The rest are of type String.
        */

    }, {
        key: 'propertyChangedHandler',
        value: function propertyChangedHandler(propertyName, oldValue, newValue) {
            babelHelpers.get(DropDownList.prototype.__proto__ || Object.getPrototypeOf(DropDownList.prototype), 'propertyChangedHandler', this).call(this, propertyName, oldValue, newValue);

            var that = this;

            switch (propertyName) {
                case 'disabled':
                    that.setFocusable(that._focusable === undefined ? true : that._focusable);
                    that.close();
                    break;
                case 'readonly':
                    that.close();
                    break;
                case 'dataSource':
                case 'displayMember':
                    //when selectedValues is 0 and displayMember is changed set actionButton text to default.
                    that.$.actionButton.innerHTML = that.placeholder;
                    break;
                case 'dropDownOpenMode':
                    that.setFocusable(that._focusable === undefined ? true : that._focusable);

                    //Close the dropDownList without throwing events.
                    that.$listBox.addClass('jqx-visibility-hidden');
                    that.$.dropDownButton.removeAttribute('selected');
                    that.$.buttonsContainer.removeAttribute('selected');
                    break;
                case 'dropDownHeight':
                case 'dropDownWidth':
                    that._setDropDownSize(propertyName === 'dropDownWidth' ? 'width' : 'height', newValue);
                    break;
                case 'dropDownVerticalPosition':
                    that._setDropDownVerticalPosition(newValue);
                    break;
                case 'selectedValues':
                case 'selectedIndexes':
                    if (newValue.length === 0) {
                        that.$.actionButton.innerHTML = that.placeholder;
                    }

                    break;
                case 'selectionDisplayMode':
                    that._applySelection(newValue);
                    break;
            }
        }

        /**
        * Appends a jqx-list-item to the end of the DropDownList.
        */

    }, {
        key: 'appendChild',
        value: function appendChild(node) {
            var that = this;

            if (!that.isCompleted) {
                var args = Array.prototype.slice.call(arguments, 2);
                return HTMLElement.prototype.appendChild.apply(that, args.concat(Array.prototype.slice.call(arguments)));
            }

            if (!node) {
                that.error(that.localize('invalidNode', { elementType: that.nodeName.toLowerCase(), method: 'appendChild', node: 'node' }));
                return;
            }

            that.$.listBox.appendChild(node);
        }

        /**
        * Removes all items from DOM.
        */

    }, {
        key: 'clearItems',
        value: function clearItems() {
            var that = this;

            that.$.listBox.clearItems();
            that.$.actionButton.innerHTML = that.placeholder;
        }

        /**
        * Unselects all items.
        */

    }, {
        key: 'clearSelection',
        value: function clearSelection() {
            var that = this;

            that.$.listBox.clearSelection();
            that.$.actionButton.innerHTML = that.placeholder;
        }

        /**
        * Hides the drop down list.
        */

    }, {
        key: 'close',
        value: function close() {
            var that = this;

            if (that.$listBox.hasClass('jqx-visibility-hidden')) {
                return;
            }

            var isOpeningEventPrevented = that.$.fireEvent('closing').defaultPrevented;

            if (isOpeningEventPrevented) {
                return;
            }

            that.$listBox.addClass('jqx-visibility-hidden');
            that.$.fireEvent('close');

            if (that.dropDownVerticalPosition === 'bottom') {
                that.$.dropDownButton.innerHTML = '&#xe804';
            } else if (that.dropDownVerticalPosition === 'top') {
                that.$.dropDownButton.innerHTML = '&#xe801';
            }

            that.$.dropDownButton.removeAttribute('selected');
            that.$.buttonsContainer.removeAttribute('selected');
        }

        /**
        * Creates a clone of the element.
        */

    }, {
        key: 'cloneNode',
        value: function cloneNode() {
            var that = this;
            var clone = HTMLElement.prototype.cloneNode.apply(that, Array.prototype.slice.call(arguments, 0, 1));

            //Set only those properties that have reflectToAttribute set to false.
            clone.dataSource = that.dataSource;
            return clone;
        }

        /**
        * Ensures the desired item is visible by scrolling to it.
        */

    }, {
        key: 'ensureVisible',
        value: function ensureVisible(item) {
            this.$.listBox.ensureVisible(item);
        }

        /**
        * Focuses an item. Accepts a JQX.ListItem element or a string, representing the value of an item.
        */

    }, {
        key: '_focus',
        value: function _focus(item) {
            this.$.listBox._focus(item);
        }

        /**
        * Returns a JQX.ListItem element if it's value is matched.
        */

    }, {
        key: 'getItem',
        value: function getItem(value) {
            return this.$.listBox.getItem(value);
        }

        /**
        * Returns an array with the items from the list.
        */

    }, {
        key: 'insert',


        /**
        * Inserts an item at a specified position.
        * @param {number} index The index at which a new item will be inserted.
        * @param {string/object/array} item Describes the properties of the item that will be inserted. 
         If string is passed, it will be processed as the label for the new item. 
         If an object is passed, it must contain valid properties for the item, e.g. { label, value, group, disabled }.
         If an array is passed, multiple items will be inserted in the list with the coressponding settings.
        */
        value: function insert(index, item) {
            var that = this;

            that.$.listBox.insert(index, item);

            //Add the item to the ActionButton if the item is selected.
            that._applySelection(that.selectionDisplayMode);
        }

        /**
        * Inserts a jqx-list-item to the DropDownList at a certain position.
        */

    }, {
        key: 'insertBefore',
        value: function insertBefore(newNode, referenceNode) {
            var that = this;

            if (!that.isCompleted) {
                var args = Array.prototype.slice.call(arguments, 2);
                return HTMLElement.prototype.insertBefore.apply(that, args.concat(Array.prototype.slice.call(arguments)));
            }

            if (!newNode || !referenceNode) {
                that.error(that.localize('invalidNode', { elementType: that.nodeName.toLowerCase(), method: 'insertBefore', node: 'newNode/referenceNode' }));
                return;
            }

            that.$.listBox.insertBefore(newNode, referenceNode);
        }

        /**
        * Shows the drop down List.
        */

    }, {
        key: 'open',
        value: function open() {
            var that = this;

            if (!that.$listBox.hasClass('jqx-visibility-hidden')) {
                return;
            }

            var isOpeningEventPrevented = that.$.fireEvent('opening').defaultPrevented;

            if (isOpeningEventPrevented) {
                return;
            }

            that.$listBox.removeClass('jqx-visibility-hidden');
            that.$.fireEvent('open');

            if (that.dropDownVerticalPosition === 'bottom') {
                that.$.dropDownButton.innerHTML = '&#xe801';
            } else if (that.dropDownVerticalPosition === 'top') {
                that.$.dropDownButton.innerHTML = '&#xe804';
            }

            if (that.dropDownOpenMode === 'dropDownButton') {
                that.$.buttonsContainer.removeAttribute('selected');
                that.$.dropDownButton.setAttribute('selected', '');
            } else {
                that.$.dropDownButton.removeAttribute('selected');
                that.$.buttonsContainer.setAttribute('selected', '');
            }

            if (!that._keyPressed && that.nodeName === 'JQX-DROP-DOWN-LIST') {
                that.$.listBox.focus();
            }
        }

        /**
        * DropDownList ready method.
        */

    }, {
        key: 'ready',
        value: function ready() {
            babelHelpers.get(DropDownList.prototype.__proto__ || Object.getPrototypeOf(DropDownList.prototype), 'ready', this).call(this);

            this._createElement();
        }

        /**
        * Removes an item from the list box.
        * @param {number} index The index at which a new item will be inserted.
        */

    }, {
        key: 'remove',
        value: function remove(index) {
            var that = this;

            that.$.listBox.remove(index);

            //Remove the item from the ActionButton if its present.
            that._applySelection(that.selectionDisplayMode);
        }

        /**
        * Removes a jqx-list-item frop the DropDownList.
        */

    }, {
        key: 'removeChild',
        value: function removeChild(node) {
            var that = this;

            if (!that.isCompleted) {
                var args = Array.prototype.slice.call(arguments, 2);
                return HTMLElement.prototype.insertBefore.apply(that, args.concat(Array.prototype.slice.call(arguments)));
            }

            if (!node || !(node instanceof JQX.ListItem)) {
                that.error(that.localize('invalidNode', { elementType: that.nodeName.toLowerCase(), method: 'removeChild', node: 'node' }));
                return;
            }

            that.$.listBox.removeChild(node);
        }

        /**
        * Selects an item by its HTML Element or Value.
        */

    }, {
        key: 'select',
        value: function select(item) {
            this.$.listBox.select(item);
        }

        /**
        * Sets tab index 
        */

    }, {
        key: 'setFocusable',
        value: function setFocusable(focusable) {
            var that = this;

            //Keep track of the focusable state between dropDownOpenMode changes.
            that._focusable = focusable;

            if (that.disabled || !that._focusable) {
                that.removeAttribute('tabindex');
                that.$.actionButton.removeAttribute('tabindex');
                that.$.dropDownButton.removeAttribute('tabindex');
                return;
            }

            var index = that.tabIndex > 0 ? that.tabIndex : 0;

            if (that.dropDownOpenMode === 'dropDownButton') {
                that.removeAttribute('tabindex');
                that.$.actionButton.setAttribute('tabindex', index);
                that.$.dropDownButton.setAttribute('tabindex', index);
            } else {
                that.$.actionButton.removeAttribute('tabindex');
                that.$.dropDownButton.removeAttribute('tabindex');
                that.tabIndex = index;
            }
        }

        /**
        * Unselects an item by its HTML Element or Value.
        */

    }, {
        key: 'unselect',
        value: function unselect(item) {
            this.$.listBox.unselect(item);
        }

        /**
        * Updates an item from the list.
        * @param {number} index The index at which a new item will be inserted.
        * @param {string/object} settings The settings that will be applied to the item that will be updated.
          If a string is passed, it will be considered as the new label for the item.
          If an object is passed, it will should describe valid properties for the item, e.g. { label, value, group, disabled}.
        */

    }, {
        key: 'update',
        value: function update(index, details) {
            var that = this;

            that.$.listBox.update(index, details);
            that._applySelection(that.selectionDisplayMode);
        }

        /**
        * Sets the selection mode for the DropDownList.
        */

    }, {
        key: '_applySelection',
        value: function _applySelection(mode) {
            var that = this;

            if (mode === 'placeholder' || that.selectedIndexes.length === 0) {
                that.$.actionButton.innerHTML = that.placeholder;
                return;
            }

            if (!that.$.listBox._items || that.$.listBox._items.length === 0) {
                return;
            }

            if (mode === 'default') {
                that.$.actionButton.innerHTML = that.selectedIndexes.map(function (i) {
                    return that.$.listBox._items[i].label;
                }).toString();
                return;
            } else {
                var doc = document;
                var fragment = doc.createDocumentFragment(),
                    element = void 0;

                that.selectedIndexes.map(function (index) {
                    element = doc.createElement('span');
                    element.innerHTML = '<span class=\'jqx-drop-down-list-selection-label\'>' + that.$.listBox._items[index].label + '</span><span class=\'jqx-drop-down-list-unselect-button\'>&#10006</span>';
                    fragment.appendChild(element);
                });

                that.$.actionButton.innerHTML = '';
                that.$.actionButton.appendChild(fragment);
            }
        }

        /**
        * Action/DropDown button mouse down event handler.
        */

    }, {
        key: '_buttonsDownHandler',
        value: function _buttonsDownHandler(event) {
            var that = this;

            if (that.disabled) {
                return;
            }

            that._preventsSelectStart = true;

            if (that.dropDownOpenMode === 'dropDownButton' && event.target === that.$.actionButton) {
                that.$actionButton.addClass('active');
            }
        }

        /**
        * DropDownList container mouse enter/leave events handler.
        */

    }, {
        key: '_buttonsMouseEventsHandler',
        value: function _buttonsMouseEventsHandler(event) {
            var that = this;

            if (that.disabled) {
                return;
            }

            event.type === 'mouseenter' ? event.target.$.addClass('hovered') : event.target.$.removeClass('hovered');
        }

        /**
        * Initializes the element.
        */

    }, {
        key: '_createElement',
        value: function _createElement() {
            var that = this;

            if (!JQX.ListBox) {
                that.error(that.localize('missingReference', { elementType: that.nodeName.toLowerCase(), files: 'jqxlistbox.js' }));
            }

            //Set properties.
            that._setDropDownSize('width', that.dropDownWidth);
            that._setDropDownSize('height', that.dropDownHeight);
            that._setDropDownVerticalPosition(that.dropDownVerticalPosition);
            that._applySelection(that.selectionDisplayMode);
            that.setFocusable(true);
        }

        /**
        * Document mouse down event handler.
        */

    }, {
        key: '_documentDownHandler',
        value: function _documentDownHandler(event) {
            var that = this;

            if (that.disabled || that.readonly) {
                return;
            }

            that._isListBoxThumbDragged = event.target !== document && event.target.classList.contains('jqx-thumb') && event.target.ownerElement.ownerElement === that.$.listBox ? true : false;
        }

        /**
        * Document Up handler.
        */

    }, {
        key: '_documentUpHandler',
        value: function _documentUpHandler(event) {
            var that = this;

            that.$actionButton.removeClass('active');

            if (that.disabled || that._isListBoxThumbDragged || that.readonly) {
                return;
            }

            var target = event.originalEvent.target;

            that._preventsSelectStart = false;

            if (target === that.$.actionButton || target === that.$.dropDownButton) {
                if (that.dropDownOpenMode === 'dropDownButton' && target === that.$.actionButton) {
                    that.close();
                    return;
                }

                //Open/Close the dropDownList
                that.$listBox.hasClass('jqx-visibility-hidden') && that.dropDownOpenMode !== 'none' ? that.open() : that.close();
                return;
            }

            if (target.classList.contains('jqx-drop-down-list-selection-label') && target.parentElement.parentElement === that.$.actionButton) {
                if (that.dropDownOpenMode !== 'none') {
                    that.open();
                }

                var item = that.$.listBox._items.filter(function (item) {
                    return item.label.toString() === target.textContent;
                })[0];

                that.$.listBox.focus();

                //Scroll to that item and focus it.
                that.$.listBox._scrollView.scrollTop = item.offsetTop;
                that._focus(item);
                return;
            }

            if (target.classList.contains('jqx-drop-down-list-unselect-button') && target.parentElement.parentElement === that.$.actionButton) {
                that.unselect(that.$.listBox._items.filter(function (item) {
                    return item.label.toString() === target.previousElementSibling.textContent;
                })[0]);
                return;
            }

            while (target) {
                if (target instanceof JQX.ListItem && target.ownerListBox === that.$.listBox) {
                    target = 'item';
                    break;
                } else if (target === that.$.listBox) {
                    target = 'listBox';
                    break;
                }

                target = target.parentElement;
            }

            if (target !== 'listBox' && target !== 'item' || target === 'item' && that.selectionMode !== 'checkBox' && that.selectionMode !== 'default' && that.selectionMode.indexOf('Many') < 0) {
                that.close();
                return;
            }
        }

        /**
        * DropDown keydown event handler.
        */

    }, {
        key: '_keyDownHandler',
        value: function _keyDownHandler(event) {
            var that = this;

            if (event.target === that.$.listBox.$.filterInput) {
                return;
            }

            switch (event.key) {
                case 'Enter':
                case ' ':
                    event.target === that ? that.$buttonsContainer.addClass('active') : event.target.$.addClass('active');
                    if (event.target !== that.$.actionButton) {
                        that._keyPressed = true;
                        that.$listBox.hasClass('jqx-visibility-hidden') && !that.readonly && that.dropDownOpenMode !== 'none' ? that.open() : that.close();
                    }

                    break;
                case 'ArrowUp':
                case 'ArrowDown':
                    if (that.readonly) {
                        return;
                    }

                    if (event.altKey) {
                        that._keyPressed = false;
                        that.$listBox.hasClass('jqx-visibility-hidden') ? that.open() : that.close();
                        return;
                    }

                    that.$.listBox._handleKeyStrokes(event.key);
                    break;
                case 'Escape':
                    that.close();
                    break;
            }
        }

        /**
        * DropDown key up event handler.
        */

    }, {
        key: '_keyUpHandler',
        value: function _keyUpHandler(event) {
            var that = this;

            if (event.target === that.$.listBox.$.filterInput) {
                return;
            }

            if (event.key === 'Enter' || event.key === ' ') {
                switch (event.target) {
                    case that:
                        that.$buttonsContainer.removeClass('active');
                        break;
                    default:
                        event.target.$.removeClass('active');
                }

                if (!that.$listBox.hasClass('jqx-visibility-hidden')) {
                    that._keyPressed = false;
                    that.$.listBox.focus();
                }
            }
        }

        /**
        * DropDownList Change event handler.
        */

    }, {
        key: '_listBoxChangeHandler',
        value: function _listBoxChangeHandler(event) {
            this._applySelection(this.selectionDisplayMode, event.detail);
        }

        /**
        * DropDownList key down handler.
        */

    }, {
        key: '_listBoxKeyDownHandler',
        value: function _listBoxKeyDownHandler(event) {
            var that = this;

            if (event.key === 'Enter') {
                that.close();
                that.dropDownOpenMode === 'dropDownButton' ? that.$.dropDownButton.focus() : that.focus();
            }

            if (event.key === 'Escape') {
                that.close();
                return;
            }
        }

        /**
        * Element container mouse enter event handler.
        */

    }, {
        key: '_mouseEnterHandler',
        value: function _mouseEnterHandler() {
            var that = this;

            that.$.addClass('hovered');

            if (that.tagName === 'JQX-DROP-DOWN-LIST' && that.dropDownOpenMode === 'auto' && !that.disabled && !that.readonly) {
                that.open();
            }
        }

        /**
        * Element container mouse leave event handler.
        */

    }, {
        key: '_mouseLeaveHandler',
        value: function _mouseLeaveHandler() {
            var that = this;

            that.$.removeClass('hovered');

            if (that.dropDownOpenMode === 'auto' && !that.disabled && !that.readonly) {
                that.close();
            }
        }

        /**
        * Document select start event handler.
        */

    }, {
        key: '_selectStartHandler',
        value: function _selectStartHandler(event) {
            if (this._preventsSelectStart) {
                event.preventDefault();
            }
        }

        /**
        * Set DropDown Size.
        */

    }, {
        key: '_setDropDownSize',
        value: function _setDropDownSize(measurement, value) {
            var that = this;

            if (value === 'auto') {
                that.$.listBox.style[measurement] = '';
                return;
            }

            value = parseFloat(value);
            that.$.listBox.style[measurement] = isNaN(value) ? '' : Math.max(0, value) + 'px';
        }

        /**
        * Set DropDown vertical position.
        */

    }, {
        key: '_setDropDownVerticalPosition',
        value: function _setDropDownVerticalPosition(value) {
            var that = this;

            if (value === 'top') {
                that.$.dropDownButton.innerHTML = '&#xe801';
                that.$.listBox.style.top = '-' + (parseFloat(that.dropDownHeight) - 1) + 'px';
                return;
            }

            that.$.listBox.style.top = '';
            that.$.dropDownButton.innerHTML = value === 'bottom' ? '&#xe804' : '&#xe806';
        }
    }, {
        key: 'items',
        get: function get() {
            if (!this.$) {
                return;
            }

            return this.$.listBox.items;
        }
    }], [{
        key: 'properties',


        /** 
        * DropDownList's properties 
        */
        get: function get() {
            return {
                'dataSource': {
                    value: null,
                    type: 'object',
                    reflectToAttribute: false
                },
                'displayLoadingIndicator': {
                    value: false,
                    type: 'boolean'
                },
                'displayMember': {
                    value: '',
                    type: 'string'
                },
                'dropDownOpenMode': {
                    allowedValues: ['none', 'default', 'dropDownButton', 'auto'],
                    value: 'default',
                    type: 'string'
                },
                'dropDownHeight': {
                    value: '200',
                    type: 'string'
                },
                'dropDownPlaceholder': {
                    value: 'No Items',
                    type: 'string'
                },
                'dropDownVerticalPosition': {
                    allowedValues: ['top', 'bottom', 'overlay'],
                    value: 'bottom',
                    type: 'string'
                },
                'dropDownWidth': {
                    value: 'auto',
                    type: 'string'
                },
                'filterable': {
                    value: false,
                    type: 'boolean'
                },
                'filterInputPlaceholder': {
                    value: '',
                    type: 'string'
                },
                'filterMode': {
                    value: 'startsWithIgnoreCase',
                    allowedValues: ['none', 'contains', 'containsIgnoreCase', 'equals', 'equalsIgnoreCase', 'startsWith', 'startsWithIgnoreCase', 'endsWith', 'endsWithIgnoreCase'],
                    type: 'string'
                },
                'grouped': {
                    value: false,
                    type: 'boolean'
                },
                'groupMember': {
                    value: '',
                    type: 'string'
                },
                'incrementalSearchDelay': {
                    value: 700,
                    type: 'number?'
                },
                'incrementalSearchMode': {
                    value: 'startsWithIgnoreCase',
                    allowedValues: ['none', 'contains', 'containsIgnoreCase', 'equals', 'equalsIgnoreCase', 'startsWith', 'startsWithIgnoreCase', 'endsWith', 'endsWithIgnoreCase'],
                    type: 'string'
                },
                'itemTemplate': {
                    value: null,
                    type: 'string?'
                },
                'itemHeight': {
                    value: null,
                    type: 'number?'
                },
                'loadingIndicatorPlaceholder': {
                    value: 'Loading...',
                    type: 'string'
                },
                'loadingIndicatorPosition': {
                    value: 'center',
                    allowedValues: ['bottom', 'center', 'top'],
                    type: 'string'
                },
                'messages': {
                    extend: true,
                    value: {
                        'en': {
                            'missingReference': '{{elementType}}: Missing reference to {{files}}.',
                            'invalidNode': '{{elementType}}: Invalid parameter "{{node}}" when calling {{method}}.'
                        }
                    },
                    type: 'object'
                },
                'placeholder': {
                    value: 'Please Select:',
                    type: 'string'
                },
                'readonly': {
                    value: false,
                    type: 'boolean'
                },
                'selectionDisplayMode': {
                    value: 'default',
                    allowedValues: ['default', 'placeholder', 'advanced'],
                    type: 'string'
                },
                'selectionMode': {
                    value: 'one',
                    allowedValues: ['none', 'default', 'zeroOrMany', 'oneOrMany', 'zeroOrOne', 'one', 'checkBox', 'radioButton'],
                    type: 'string'
                },
                'selectedIndexes': {
                    value: [],
                    type: 'array'
                },
                'selectedValues': {
                    value: [],
                    type: 'array'
                },
                'sorted': {
                    value: false,
                    type: 'boolean'
                },
                'valueMember': {
                    value: '',
                    type: 'string'
                },
                'virtualized': {
                    value: false,
                    type: 'boolean'
                }
            };
        }

        /**
        * DropDownList's event listeners.
        */

    }, {
        key: 'listeners',
        get: function get() {
            return {
                'actionButton.down': '_buttonsDownHandler',
                'actionButton.mouseenter': '_buttonsMouseEventsHandler',
                'actionButton.mouseleave': '_buttonsMouseEventsHandler',
                'document.selectstart': '_selectStartHandler',
                'document.down': '_documentDownHandler',
                'document.up': '_documentUpHandler',
                'dropDownButton.down': '_buttonsDownHandler',
                'dropDownButton.mouseenter': '_buttonsMouseEventsHandler',
                'dropDownButton.mouseleave': '_buttonsMouseEventsHandler',
                'keydown': '_keyDownHandler',
                'keyup': '_keyUpHandler',
                'listBox.change': '_listBoxChangeHandler',
                'listBox.keydown': '_listBoxKeyDownHandler',
                'mouseenter': '_mouseEnterHandler',
                'mouseleave': '_mouseLeaveHandler'
            };
        }
    }]);
    return DropDownList;
}(JQX.ContentElement));